import {CreateUserRequest, CreateUserResponse, ICreateUserRequest, space} from "../../compiled";
import {useRpcSender} from "../../RpcSender";
import {RpcState} from "../RpcState";
import {useState} from "react";
import {useProfile} from "../../UserProfileProvider";
import IErrorProto = space.kenko.proto.IErrorProto;

export const useCreateUserRpc = () => {

  const {setProfile} = useProfile();
  const rpcSender = useRpcSender();
  const [rpcState, setRpcState] = useState<RpcState>({state: 'none'})
  const [errors, setErrors] = useState<IErrorProto[]>([]);

  const send = (request: ICreateUserRequest) => {

    setRpcState({state: 'pending'});
    setErrors([]);
    rpcSender.send('create_user', CreateUserRequest.encode(request).finish())
        .then(value => {
          const response = CreateUserResponse.decode(value);
          setProfile(response.profile);
          setErrors(response.errors);
          
          if (!response.profile) {
            setRpcState({state: 'error'});
          } else {
            setRpcState({state: 'success'});
          }
        })
        .catch(e => {
          setRpcState({state: 'error', message: 'Error creating your profile. Please try again later.'});
        });
          return;
  }
  
  return {rpcState, errors, send}
}